import React, { ReactNode, Children } from 'react';
import classNames from 'classnames';
import NavigationVariantType from './types/NavigationVariantType';
import Accordion from '../Accordion';

export interface HeaderDropdownProps {
  children: ReactNode;
  title: string;
  navigationVariant: NavigationVariantType;
  /**
   * Set to true to indicate current section
   *
   */
  current?: boolean;
}

const HeaderDropdown = ({ children, navigationVariant, title, current }: HeaderDropdownProps): JSX.Element => {
  const dropdownButtonClassNames = classNames({
    'usa-nav__link': true,
    'usa-current': current,
  });

  const subMenuClassNames = classNames({
    'usa-nav__submenu': true,
    'usa-megamenu': navigationVariant === NavigationVariantType.Mega,
  });

  const ariaControlsId = `primary-item-${title.toLowerCase().replace(/\W/g, '-')}`;

  if (navigationVariant === NavigationVariantType.Basic || navigationVariant === NavigationVariantType.None) {
    return (
      <>
        <Accordion.Button controls={ariaControlsId} className={dropdownButtonClassNames}>
          <span aria-controls={ariaControlsId}>{title}</span>
        </Accordion.Button>
        <Accordion.Content id={ariaControlsId} as="ul" className={subMenuClassNames} variant="unstyled">
          {children && Children.map(children, (child) => <li className="usa-nav__submenu-item">{child}</li>)}
        </Accordion.Content>
      </>
    );
  }
  return (
    <>
      <Accordion.Button controls={ariaControlsId} className={dropdownButtonClassNames}>
        <span aria-controls={ariaControlsId}>{title}</span>
      </Accordion.Button>
      <Accordion.Content id={ariaControlsId} as="div" className={subMenuClassNames} variant="unstyled">
        <div className="grid-row grid-gap-4">{children}</div>
      </Accordion.Content>
    </>
  );
};

export default HeaderDropdown;
